itsoftApp.createModule("parallaxMouse", ["loadModule"], function() {
    // var TABLET_WIDTH = 1024;
    // var viewportSize = itsoftApp.utils.getViewportSize();

    var module = this;
    var libraries = {
        parallax: {
            name: "parallaxMouse",
            queue: [],
            started: false,
            loaded: false,
            script: "/assets/scripts/parallax/parallax.min.js"
        }
    }

    // var onWindowResize = function () {
    //     viewportSize = itsoftApp.utils.getViewportSize();
    //     // if (scenes && viewportSize >= TABLET_WIDTH && !initialized) {
    //         initialized = true;
    //         initParallax();
    //         window.removeEventListener("resize", onWindowResize);
    //     // }
    // }

    var initParallax = function (el) {
        // setTimeout(function () {
            if (el.classList.contains("scene--no-transition")) {
                el.classList.add("scene--active");
            }

            console.log(el)

            var parallax = new Parallax(el, {
                relativeInput: true,
                clipRelativeInput: true
            });
        // }, 2700);
    }

    var init = function (el) {
        itsoftApp.modules.loadModule.callback(function () {
            initParallax(el);
        }, libraries.parallax);
    }

    module.callback = init;
});